import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const Photo360Icon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="photo360" ref={ref} {...props}>
      <path d="M22.34,7.41a15,15,0,0,0-2-.77,9.9,9.9,0,0,0-16.6,0,15,15,0,0,0-2,.77.75.75,0,0,0-.42.68V16a.75.75,0,0,0,.42.67,14.74,14.74,0,0,0,2.08.78,9.88,9.88,0,0,0,16.5,0,14.74,14.74,0,0,0,2.08-.78.75.75,0,0,0,.42-.67V8.09A.75.75,0,0,0,22.34,7.41ZM12,3.64A8.34,8.34,0,0,1,17.88,6,29.8,29.8,0,0,0,12,5.46,29.8,29.8,0,0,0,6.14,6,8.34,8.34,0,0,1,12,3.64Zm0,16.72A8.34,8.34,0,0,1,6.19,18a29.34,29.34,0,0,0,5.82.57A29.34,29.34,0,0,0,17.83,18,8.34,8.34,0,0,1,12,20.36Zm9.25-4.88c-.35.13-.9.34-1.64.56h-.08l0,0s-3.63-4.16-4.23-4.63a1.27,1.27,0,0,0-1.68-.11c-.56.38-2,1.65-2.51,2.07a1.23,1.23,0,0,1-1.56,0c-.5-.31-.89-.54-1.51,0S5.8,15.41,5,16.19l-.51-.14h0c-.74-.22-1.29-.43-1.64-.56V8.58A25.09,25.09,0,0,1,12,7a25.25,25.25,0,0,1,9.25,1.62ZM10.5,10A1.4,1.4,0,1,1,9.11,8.64,1.4,1.4,0,0,1,10.5,10Z" />
    </Icon>
  ),
) as IconWithRender;

Photo360Icon.displayName = 'Photo360Icon';
Photo360Icon.renderIcon = (props) => <Photo360Icon {...props} />;
export default Photo360Icon;
